/** API ممکن است camelCase یا PascalCase برگرداند */
export const pickReportField = (row, camel, pascal) =>
  row?.[camel] ?? row?.[pascal] ?? null;

export const normalizeReportRow = (row) => ({
  operationModule: pickReportField(row, "operationModule", "OperationModule"),
  operationModuleTitle: pickReportField(
    row,
    "operationModuleTitle",
    "OperationModuleTitle"
  ),
  requestInfoId: pickReportField(row, "requestInfoId", "RequestInfoId"),
  requestTrackingCode: pickReportField(
    row,
    "requestTrackingCode",
    "RequestTrackingCode"
  ),
  applicantFullName: pickReportField(row, "applicantFullName", "ApplicantFullName"),
  applicantMobile: pickReportField(row, "applicantMobile", "ApplicantMobile"),
  processId: pickReportField(row, "processId", "ProcessId"),
  processTypeTitle: pickReportField(row, "processTypeTitle", "ProcessTypeTitle"),
  currentStatusTitle: pickReportField(
    row,
    "currentStatusTitle",
    "CurrentStatusTitle"
  ),
  statusColor: pickReportField(row, "statusColor", "StatusColor"),
  referenceNumber: pickReportField(row, "referenceNumber", "ReferenceNumber"),
  trackingCode: pickReportField(row, "trackingCode", "TrackingCode"),
  lendingPartnerTitle: pickReportField(
    row,
    "lendingPartnerTitle",
    "LendingPartnerTitle"
  ),
  lastActionAt: pickReportField(row, "lastActionAt", "LastActionAt"),
  lastActionByFullName: pickReportField(
    row,
    "lastActionByFullName",
    "LastActionByFullName"
  ),
  openDays: pickReportField(row, "openDays", "OpenDays") ?? 0,
  lastActionTitle: pickReportField(row, "lastActionTitle", "LastActionTitle"),
  requestStepTitle: pickReportField(row, "requestStepTitle", "RequestStepTitle"),
  slaStatus: pickReportField(row, "slaStatus", "SlaStatus"),
  slaStatusTitle: pickReportField(row, "slaStatusTitle", "SlaStatusTitle"),
  slaColor: pickReportField(row, "slaColor", "SlaColor"),
  assignedToUserId: pickReportField(row, "assignedToUserId", "AssignedToUserId"),
  assignedToFullName: pickReportField(row, "assignedToFullName", "AssignedToFullName"),
  assignedAt: pickReportField(row, "assignedAt", "AssignedAt"),
});

/** fallback اگر API فیلد SLA نفرستاد */
export const resolveSlaFromOpenDays = (openDays) => {
  const days = Number(openDays) || 0;
  if (days >= 7) {
    return { slaStatus: "overdue", slaStatusTitle: "عقب‌افتاده", slaColor: "error" };
  }
  if (days >= 3) {
    return {
      slaStatus: "attention",
      slaStatusTitle: "نیازمند توجه",
      slaColor: "warning",
    };
  }
  return { slaStatus: "normal", slaStatusTitle: "عادی", slaColor: "success" };
};

export const ensureRowSla = (row) => {
  if (row?.slaStatus) return row;
  const sla = resolveSlaFromOpenDays(row?.openDays);
  return { ...row, ...sla };
};

export const SLA_FILTER_OPTIONS = [
  { value: "", label: "همه" },
  { value: "overdue", label: "عقب‌افتاده" },
  { value: "attention", label: "نیازمند توجه" },
  { value: "normal", label: "عادی" },
];
